var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass:
        "fc-cus-event fc-cus-event--margin fc-time-grid-event fc-v-event fc-event fc-start fc-end fc-draggable ",
      class: [_vm.className, _vm.resizable, _vm.shadow],
      style: _vm.style,
      on: { click: _vm.handleContainerClick }
    },
    [
      _c(
        "div",
        { staticClass: "fc-content" },
        [
          _c(
            "v-menu",
            {
              staticClass: "menu-content agenda-item-menu",
              style: _vm.eventItemStyle,
              attrs: {
                "content-class": "calendar-menu-popover",
                "close-on-content-click": false,
                "max-width": 400,
                "nudge-width": 200,
                "offset-y": ""
              },
              model: {
                value: _vm.dtMenu,
                callback: function($$v) {
                  _vm.dtMenu = $$v
                },
                expression: "dtMenu"
              }
            },
            [
              _c("template", { slot: "activator" }, [
                _c(
                  "div",
                  {
                    staticClass: "fc-time",
                    attrs: {
                      "data-start": _vm.start,
                      "data-full": _vm.fullDate
                    }
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.fullDate))])]
                )
              ]),
              _vm._v(" "),
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    {
                      staticClass: "headline primary--text pt-2 pm-2 pl-1 pr-2",
                      staticStyle: { "padding-bottom": "0 !important" }
                    },
                    [
                      _c(
                        "v-layout",
                        {
                          attrs: {
                            row: "",
                            "align-center": "",
                            "justify-end": ""
                          }
                        },
                        [
                          _vm.coCanUpdate
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "ma-0 delete-button",
                                  attrs: { small: "", flat: "", icon: "" },
                                  on: {
                                    click: function($event) {
                                      _vm.handleUpdate(_vm.event)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "greyDark", small: "" } },
                                    [_vm._v("edit")]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.coCanRemove
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "ma-0 delete-button",
                                  attrs: { small: "", flat: "", icon: "" },
                                  on: {
                                    click: function($event) {
                                      _vm.handleDelete(_vm.event)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "red", small: "" } },
                                    [_vm._v("delete")]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "ma-0 delete-button",
                              attrs: { small: "", flat: "", icon: "" },
                              on: {
                                click: function($event) {
                                  _vm.dtMenu = false
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                { attrs: { small: "", color: "greyDark" } },
                                [_vm._v("close")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-card-text",
                        {
                          staticClass: "p-0 m-0",
                          staticStyle: { "padding-top": "0 !important" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "justify-content": "center",
                                "align-items": "center",
                                "margin-bottom": "5px"
                              }
                            },
                            [
                              _c("span", {
                                staticClass:
                                  "primary--text mb-3 agenda-popover__title",
                                domProps: { textContent: _vm._s(_vm.title) }
                              }),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c("i", {
                                staticClass:
                                  "icon icon-blocks primary--text mx-1"
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "primary--text",
                                staticStyle: {
                                  "font-size": "16px",
                                  "font-weight": "bold"
                                },
                                domProps: { textContent: _vm._s(_vm.coBlock) }
                              }),
                              _vm._v(" "),
                              _c("br")
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.coICs, function(ic, index) {
                            return _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "100%",
                                  float: "left",
                                  display: "block",
                                  "margin-bottom": "5px"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "agenda-popover__person primary--text",
                                    staticStyle: { float: "left" }
                                  },
                                  [_c("span", [_vm._v(_vm._s(ic.avatar))])]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticStyle: { display: "inline" } },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "primary--text",
                                        staticStyle: {
                                          float: "left",
                                          "font-size": "13px !important",
                                          "font-weight": "bold"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(ic.firstname) +
                                            _vm._s(" ") +
                                            _vm._s(ic.lastname)
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c(
                                      "small",
                                      {
                                        staticClass: "primary--text",
                                        staticStyle: {
                                          float: "left",
                                          "font-size": "14px",
                                          "font-style": "italic"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(ic.email) +
                                            "\n                  "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          " " +
                                            _vm._s(ic.cellphone) +
                                            "\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("br")
                                  ]
                                )
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticStyle: {
                              display: "block",
                              float: "left",
                              width: "100%"
                            }
                          }),
                          _vm._v(" "),
                          _vm.coDescription
                            ? _c(
                                "div",
                                { staticClass: "agenda-popover__desc" },
                                [
                                  _c("span", {
                                    staticClass: "primary--text",
                                    domProps: {
                                      textContent: _vm._s(_vm.coDescription)
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "fc-tooltip-timing--padding" },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "" } },
                        [
                          _c(
                            "v-icon",
                            { staticClass: "mr-2 ml-1 mb-2 primary--text" },
                            [_vm._v("schedule")]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "primary--text" }, [
                            _vm._v(
                              _vm._s(_vm.$t("AGENDA_START")) +
                                ": " +
                                _vm._s(_vm.startDate) +
                                " " +
                                _vm._s(_vm.start)
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "" } },
                        [
                          _c(
                            "v-icon",
                            { staticClass: "mr-2 ml-1 primary--text" },
                            [_vm._v("alarm_on")]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "primary--text" }, [
                            _vm._v(
                              _vm._s(_vm.$t("AGENDA_END")) +
                                ":" +
                                _vm._s(_vm.endDate) +
                                " " +
                                _vm._s(_vm.end)
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.isAppointment
                        ? _c("v-layout", { attrs: { row: "" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "primary--text",
                                staticStyle: { width: "100%" }
                              },
                              [
                                _c("v-btn", {
                                  staticClass: "primary--text convert-button",
                                  staticStyle: { float: "right" },
                                  attrs: { color: "turquoise" },
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t(_vm.lblSettingButtonText)
                                    )
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.handleConvert(_vm.event)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "fc-title" }, [
            _c("span", {
              staticStyle: { width: "100%", display: "inherit" },
              domProps: { textContent: _vm._s(_vm.coBlock) }
            }),
            _vm._v(" "),
            _c("span", {
              staticClass: "title",
              domProps: { textContent: _vm._s(_vm.title) }
            })
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "fc-bg" }),
      _vm._v(" "),
      _c("div", { staticClass: "fc-resizer fc-end-resizer" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09c1b5fa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09c1b5fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/agenda/components/agenda-event-item/template.html
// module id = null
// module chunks = 